<div class="container-fluid custom-modal-container" *ngIf="context && context.model">
  <div class="custom-modal-container-content appearance">
    <div class="appearance-wrap">
      <div (click)="onClose()" class="close-button">
        <svg class="icon-svg">
          <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#dialog-cross"></use>
        </svg>
      </div>

      <ul class="appearance-tabs">
        <li class="appearance-tabs-item" *ngFor="let tab of context.tabs">
          <a class="appearance-tabs-btn" (click)="changeTab(tab.id)" [ngClass]="{ active: tab.id === context.appearanceType }">{{
            tab.text | translate
          }}</a>
        </li>
      </ul>

      <div class="appearance-content">
        <div class="appearance-tab">
          <button
            class="appearance-tab-item"
            [ngClass]="{ active: context.model.currentType === dataTypes.Type }"
            (click)="onTabSwitch(dataTypes.Type)"
          >
            <span class="appearance-tab-icon">
              <svg class="icon-svg">
                <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-type"></use>
              </svg>
            </span>
            <span class="appearance-tab-name" [innerText]="'Type' | translate"></span>
          </button>
          <button
            class="appearance-tab-item"
            [ngClass]="{ active: context.model.currentType === dataTypes.Draw }"
            (click)="onTabSwitch(dataTypes.Draw)"
          >
            <span class="appearance-tab-icon">
              <svg class="icon-svg">
                <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-draw"></use>
              </svg>
            </span>
            <span class="appearance-tab-name" [innerText]="'Draw' | translate"></span>
          </button>
          <button
            class="appearance-tab-item"
            [ngClass]="{ active: context.model.currentType === dataTypes.Image }"
            (click)="onTabSwitch(dataTypes.Image)"
          >
            <span class="appearance-tab-icon">
              <svg class="icon-svg">
                <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-image"></use>
              </svg>
            </span>
            <span class="appearance-tab-name" [innerText]="'Image' | translate"></span>
          </button>
        </div>
        <div class="appearance-container">
          <div id="draw" *ngIf="context.model.currentType === dataTypes.Draw" class="tabcontent">
            <app-draw-canvas
              [description]="context.phrases[context.title].drawHere | translate"
              [model]="context.model.tabs[dataTypes.Draw]"
              (onDraw)="setData($event, dataTypes.Draw)"
              (onClear)="clear($event, dataTypes.Draw)"
            >
            </app-draw-canvas>
          </div>
          <ng-container *ngIf="context.model.currentType === dataTypes.Type">
            <app-signature-and-initial-type
              [context]="context"
              [fonts]="fonts"
              [dataTypes]="dataTypes"
              [color]="currentTypeColor"
              (selectedItem)="onSelectedType($event)"
              (isEmptyText)="checkTextState($event)"
            >
            </app-signature-and-initial-type>
          </ng-container>
          <div id="image" *ngIf="context.model.currentType === dataTypes.Image" class="tabcontent">
            <app-image-upload
              [description]="context.phrases.limit | translate"
              [model]="context.model.tabs[dataTypes.Image]"
              [buttonCaption]="'Upload an image of your signature' | translate"
              [extensions]="supportedExtensions"
              [maxFileSize]="maxFileSize"
              (onImageUploadFinish)="setData($event, dataTypes.Image)"
              (onRemove)="clear($event, dataTypes.Image)"
            >
            </app-image-upload>
          </div>

          <div class="appearance-bottom">
            <div class="appearance-paragraph-wrap">
              <p *ngIf="message" [innerText]="message | translate"></p>
              <p class="appearance-paragraph" [innerText]="context.phrases[context.title].legal | translate"></p>
            </div>

            <div class="appearance-btn-wrap">
              <a class="appearance-btn apply-btn" [ngClass]="{ disabled: isEmptyText }" (click)="onApply()" [innerText]="'Apply' | translate"></a>
              <a (click)="onClose()" class="apply-btn apply-btn-cancel" [innerText]="'Cancel' | translate"></a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="color-picker" *ngIf="context.model.currentType === dataTypes.Type || context.model.currentType === dataTypes.Draw">
      <ng-container>
        <app-color-picker *ngIf="context.model.currentType === dataTypes.Draw" [currentColor]="currentDrawColor" [isDefault]="true" [type]="'draw'">
        </app-color-picker>

        <app-color-picker *ngIf="context.model.currentType === dataTypes.Type" [currentColor]="currentTypeColor" [isDefault]="true" [type]="'type'">
        </app-color-picker>
      </ng-container>
    </div>
  </div>
</div>
